export default __webpack_public_path__ + "static/media/payment-telekom.a827ebb2.svg";